import { useEffect, useRef } from 'react';

interface IShortcutConfig {
  [key: string]: Function;
}

const useKeyboardShortcuts = (config: IShortcutConfig) => {
  const shortcutMap = useRef(config);

  useEffect(() => {
    const keydownHandler = (event: KeyboardEvent) => {
      const { key } = event;
      if (!shortcutMap.current[key]) return;

      if (key.includes('Arrow')) {
        event.preventDefault();
      }

      shortcutMap.current[key]();
    };

    window.addEventListener('keydown', keydownHandler);

    return () => {
      window.removeEventListener('keydown', keydownHandler);
    };
  }, [shortcutMap]);
};

export default useKeyboardShortcuts;
